module.exports = __webpack_public_path__ + "static/img/安吉尔空间大师系列M7 Home Pro 800.484a25c9.png";